import './add-credit-card-modal.scss';
import AddCreditCardContent from '../../shared/add-crdit-card/AddCreditCardContent';

const AddCreditCardModal = () => {
  return (
    <div className="add-credit-card-modal">
      <AddCreditCardContent />
    </div>
  );
};

export default AddCreditCardModal;
